// Turnos sin horario (time=null) deben quedar al final, no al principio.
// '99:99' es mayor que cualquier hora real (HH:MM o HH:MM:SS), así que
// localeCompare los empuja siempre al final del listado.
export function compararTurnosPorHorario(a, b) {
  return (a.time || '99:99').localeCompare(b.time || '99:99');
}

export function ordenarTurnosPorHorario(citas) {
  return [...citas].sort(compararTurnosPorHorario);
}
